import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonicalUrl, ogImage, ogType, schema }) => {
    const siteTitle = 'Peregrine Tours & Safaris';
    const siteUrl = 'https://www.peregrinetoursandsafaris.com';
    const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    const metaDescription = description || "Embark on unforgettable journeys through Southern & Eastern Africa with Peregrine Tours & Safaris. Luxury safaris, Victoria Falls adventures, and more.";
    const metaKeywords = keywords || "African Safari, Victoria Falls, Zambia Tours, Wildlife Safari, Adventure Travel, Maasai Mara, Safari Tours, Peregrine Tours";
    const image = ogImage || `${siteUrl}/images/safari.webp`;
    const type = ogType || 'website';

    return (
        <Helmet>
            {/* Standard Meta Tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="keywords" content={metaKeywords} />
            {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:site_name" content={siteTitle} />
            <meta property="og:url" content={canonicalUrl || siteUrl} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={image} />

            {/* JSON-LD Structured Data */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(schema)}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;

